query Post($id: ID!) {
  post(id: $id) {
    id
    title
    description
    text
    slug
    path
    url
    organization {
      id
      title
    }
    image {
      id
      url(format: HIGH)
    }
    tags {
      id
      title
    }
    publishAt
    accessOnlyViaLink
    createdAt
    updatedAt
  }
}
